import IconCorner from "../Icons/IconCorner";
import { twMerge } from "tailwind-merge";

interface Props {
  title: string;
  className?: string;
}

const HeaderTitle: React.FC<Props> = ({ title, className }) => {
  const titleClasses = twMerge("ml-2 text-2xl font-semibold", className);
  return (
    <div className="flex">
      <IconCorner />
      <p className={titleClasses}>{title}</p>
    </div>
  );
};

export default HeaderTitle;
